import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";

const NewProducts = () => {
    return (
        <div className="new-products-wrapper">
            <div className="container">
                <div className="title">
                    <div className="title-box just-text title-box-blue">
                        <div className="title-bg">
                                <h2 className="text">
                                    محصولات جدید
                                </h2>
                        </div>
                        <div className="more">
                            <span className="d-none d-sm-inline"><a href="#">بیشتر</a></span>
                            <a href="#"><IconName name="chevron_left" className="icon"/></a>
                        </div>
                    </div>
                </div>
                <div className="new-products">
                    <div className="top-slider">
                        <div className="swiper new-products xpt-6">
                            <div className="swiper-wrapper">
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div
                                            className="new-product-slide-box d-flex justify-content-center align-items-center">
                                            <img src="./assets/sample-image/HNHD2.png" alt="ساعت هوشمند"
                                                 className="img-fluid"/>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div
                                            className="new-product-slide-box d-flex justify-content-center align-items-center">
                                            <img src="./assets/sample-image/MU9F2.png" alt="ساعت هوشمند"
                                                 className="img-fluid"/>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div
                                            className="new-product-slide-box d-flex justify-content-center align-items-center">
                                            <img src="./assets/sample-image/apple-iphone-1.png" alt="ساعت هوشمند"
                                                 className="img-fluid"/>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div
                                            className="new-product-slide-box d-flex justify-content-center align-items-center">
                                            <img
                                                src="./assets/sample-image/kisspng-xiaomi-mi-band-gps-navigation-systems-amazfit-smar-xiaomi-amazfit-pa-2.png"
                                                alt="ساعت هوشمند" className="img-fluid"/>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div
                                            className="new-product-slide-box d-flex justify-content-center align-items-center">
                                            <img
                                                src="./assets/sample-image/XIAOMI-Mi-Ionic-Hair-Dryer-Wei--Haartrockner--2.png"
                                                alt="ساعت هوشمند" className="img-fluid"/>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div
                                            className="new-product-slide-box d-flex justify-content-center align-items-center">
                                            <img src="./assets/sample-image/Xiaomi-Mi-Power-Bank-5000-mAh.png"
                                                 alt="ساعت هوشمند" className="img-fluid"/>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div
                                            className="new-product-slide-box d-flex justify-content-center align-items-center">
                                            <img src="./assets/sample-image/MV6Y2.png" alt="ساعت هوشمند"
                                                 className="img-fluid"/>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div
                                            className="new-product-slide-box d-flex justify-content-center align-items-center">
                                            <img src="./assets/sample-image/HNHD2.png" alt="ساعت هوشمند"
                                                 className="img-fluid"/>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div
                                            className="new-product-slide-box d-flex justify-content-center align-items-center">
                                            <img src="./assets/sample-image/Xiaomi-Mi-Power-Bank-5000-mAh.png"
                                                 alt="ساعت هوشمند" className="img-fluid"/>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div
                                            className="new-product-slide-box d-flex justify-content-center align-items-center">
                                            <img
                                                src="./assets/sample-image/XIAOMI-Mi-Ionic-Hair-Dryer-Wei--Haartrockner--2.png"
                                                alt="ساعت هوشمند" className="img-fluid"/>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bottom-slider xmt-4 xmt-md-6">
                        <div className="swiper new-products">
                            <div className="swiper-wrapper xmr-22">
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div
                                            className="new-product-slide-box d-flex justify-content-center align-items-center">
                                            <img
                                                src="./assets/sample-image/XIAOMI-Mi-Metal-Carry-on-Luggage-20“-Handgepäck-silber-Koffer--Silber.png"
                                                alt="ساعت هوشمند" className="img-fluid"/>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div
                                            className="new-product-slide-box d-flex justify-content-center align-items-center">
                                            <img src="./assets/sample-image/HJ162_FV406.png" alt="ساعت هوشمند"
                                                 className="img-fluid"/>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div
                                            className="new-product-slide-box d-flex justify-content-center align-items-center">
                                            <img
                                                src="./assets/sample-image/FAVPNG_electric-bicycle-xiaomi-scooter-folding-bicycle_Av-2.png"
                                                alt="ساعت هوشمند" className="img-fluid"/>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div
                                            className="new-product-slide-box d-flex justify-content-center align-items-center">
                                            <img src="./assets/sample-image/MWP-1.png" alt="ساعت هوشمند"
                                                 className="img-fluid"/>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div
                                            className="new-product-slide-box d-flex justify-content-center align-items-center">
                                            <img src="./assets/sample-image/HNGK-1.png" alt="ساعت هوشمند"
                                                 className="img-fluid"/>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div
                                            className="new-product-slide-box d-flex justify-content-center align-items-center">
                                            <img src="./assets/sample-image/MRJ72.png" alt="ساعت هوشمند"
                                                 className="img-fluid"/>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div
                                            className="new-product-slide-box d-flex justify-content-center align-items-center">
                                            <img src="./assets/sample-image/kisspng-xiaomi-mi-band-3.png"
                                                 alt="ساعت هوشمند"
                                                 className="img-fluid"/>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div
                                            className="new-product-slide-box d-flex justify-content-center align-items-center">
                                            <img src="./assets/sample-image/HNHD2.png" alt="ساعت هوشمند"
                                                 className="img-fluid"/>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div
                                            className="new-product-slide-box d-flex justify-content-center align-items-center">
                                            <img
                                                src="./assets/sample-image/FAVPNG_electric-bicycle-xiaomi-scooter-folding-bicycle_Av-2.png"
                                                alt="ساعت هوشمند" className="img-fluid"/>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div
                                            className="new-product-slide-box d-flex justify-content-center align-items-center">
                                            <img src="./assets/sample-image/HNGK-1.png" alt="ساعت هوشمند"
                                                 className="img-fluid"/>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewProducts;
